import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

/**
 * ProtectedRoute — guards routes by auth state and role.
 *
 * @param {string}  role     — required role ("student" | "admin")
 * @param {React.ReactNode} children — the protected page
 */
const ProtectedRoute = ({ role, children }) => {
  const { isAuthenticated, user, loading } = useAuth();
  const location = useLocation();

  // While checking stored session, show nothing (avoids flash)
  if (loading) {
    return (
      <div className="min-h-screen bg-ku-cream flex items-center justify-center">
        <div className="w-8 h-8 border-4 border-ku-purple/20 border-t-ku-purple rounded-full animate-spin" />
      </div>
    );
  }

  // Not logged in → redirect to appropriate login
  if (!isAuthenticated) {
    const loginPath = role === "admin" ? "/volunteer/login?tab=admin" : "/volunteer/login";
    return <Navigate to={loginPath} replace state={{ from: location }} />;
  }

  // Wrong role → redirect to their correct dashboard
  if (role === "admin" && user?.role !== "admin") {
    return <Navigate to="/volunteer/dashboard" replace />;
  }
  if (role === "student" && user?.role !== "student") {
    return <Navigate to="/admin/dashboard" replace />;
  }

  return children;
};

export default ProtectedRoute;
